module.exports = __webpack_public_path__ + "static/media/students.2f51548e.png";